var map = {
	"./AdaIDE.dark.png": 256,
	"./AdaIDE.darkplus.png": 4936,
	"./AdaIDE.default.png": 9872,
	"./AdaIDE.pink.png": 1004,
	"./CCmake.dark.png": 7744,
	"./CCmake.darkplus.png": 6292,
	"./CCmake.default.png": 8508,
	"./CCmake.pink.png": 2604,
	"./DiffofTwoCompilers.dark.png": 1557,
	"./DiffofTwoCompilers.darkplus.png": 6260,
	"./DiffofTwoCompilers.default.png": 3096,
	"./DiffofTwoCompilers.pink.png": 6484,
	"./DiffofTwoSources.dark.png": 1996,
	"./DiffofTwoSources.darkplus.png": 6452,
	"./DiffofTwoSources.default.png": 2140,
	"./DiffofTwoSources.pink.png": 392,
	"./JavaIDE.dark.png": 3636,
	"./JavaIDE.darkplus.png": 9736,
	"./JavaIDE.default.png": 2444,
	"./JavaIDE.pink.png": 3424,
	"./LLVMIR.dark.png": 5104,
	"./LLVMIR.darkplus.png": 7196,
	"./LLVMIR.default.png": 3804,
	"./LLVMIR.pink.png": 9943,
	"./PascalIDE.dark.png": 9524,
	"./PascalIDE.darkplus.png": 796,
	"./PascalIDE.default.png": 6864,
	"./PascalIDE.pink.png": 4764,
	"./Preprocessor.dark.png": 9536,
	"./Preprocessor.darkplus.png": 2168,
	"./Preprocessor.default.png": 5528,
	"./Preprocessor.pink.png": 1403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4912;